require('./../bootstrap');

import { createApp, h } from 'vue'
import {createInertiaApp, usePage} from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia';

// import ziggy vue pluging and ziggy routes
import { ZiggyVue } from 'ziggy';
import { Ziggy } from '../ziggy';

import { i18nVue } from 'laravel-vue-i18n'
import MainLayout from './Layouts/Main'

// setting up a global route method
import route from '../../../vendor/tightenco/ziggy/src/js/index';
Ziggy.defaults = {locale: document.documentElement.getAttribute('data-w3r-locale-url')};
window.route = function (name, params = {}, absolute = false) {
    params.locale = usePage().props.value.localeUrl || document.documentElement.getAttribute('data-w3r-locale-url');
    if(usePage().props.value.metaDataType && usePage().props.value.metaDataType.url && Ziggy.routes[name].uri.indexOf('metaDataType') !== -1) {
        params.metaDataType = usePage().props.value.metaDataType.url;
    }

    return route(name, params, absolute, Ziggy);
};

let app = createInertiaApp({
    resolve: name => {
        const page = require(`./Pages/${name}`).default
        page.layout = page.layout || MainLayout
        return page
    },
    setup({ el, App, props, plugin }) {
        let app = createApp({ render: () => h(App, props) });
        app.use(plugin)
        app.use(ZiggyVue, Ziggy);
        app.mount(el);

        Inertia.on('navigate', (event) => {
            if(window.gtagAnalytics) {
                window.gtagAnalytics('event', 'page_view', {
                    'page_location': event.detail.page.url
                });
            }
        })
    },
    title: title => `${title} - web3register.org`,
});

